module.exports = __webpack_public_path__ + "img/red-heart-in-childrens-hands-on-a-blue-background-close-up1.ae937dc4.png";